var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "bordered mb-1 bar-tab-items-table",
        attrs: {
          "show-empty": "",
          "empty-text": _vm.$t("Nenhum produto consumido"),
          fields: _vm.itemFields,
          items: _vm.getItems,
          "tbody-tr-class": _vm.getRowClass,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(name)",
            fn: function (row) {
              return [
                _c("bar-tab-consumption-item-name", {
                  attrs: { item: row.item },
                }),
              ]
            },
          },
          {
            key: "cell(price)",
            fn: function (row) {
              return [
                row.item.unitDiscount > 0
                  ? [
                      _c("span", { staticClass: "item-canceled-price" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("currency")(row.item.unitValue)) +
                            " "
                        ),
                      ]),
                      _c("br"),
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm._f("currency")(row.item.price)) + " "
                        ),
                      ]),
                    ]
                  : [
                      _vm._v(
                        " " + _vm._s(_vm._f("currency")(row.item.price)) + " "
                      ),
                    ],
              ]
            },
          },
          {
            key: "cell(netValue)",
            fn: function (ref) {
              var item = ref.item
              return [
                item.isKitItem
                  ? [_vm._v(" " + _vm._s(" ") + " ")]
                  : [
                      _vm._v(
                        " " + _vm._s(_vm._f("currency")(item.netValue)) + " "
                      ),
                    ],
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }